<template>
  <v-container class="pa-0">
    <v-card class="pa-3 ma-0" v-if="!loading">
      <vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series"></vue-apex-charts>
    </v-card>
    <v-card v-show="loading" class="mt-5">
      <v-row align="center" justify="center" style="height: 350px;">
        <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import axios from 'axios'
import VueApexCharts from "vue-apexcharts";
export default {
  name: "ChartAttendancePW",
  components: {
    VueApexCharts,
  },
  props: ["companyId", "year", "companyName", "week"],
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      data: {},
      loading: false,
      series: [{ name: 'data', data: [] },],
      chartOptions: {
        title: {
          text: '',
          align: 'center',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: { fontSize: '14px', fontWeight: 'bold', color: '#263238' },
        },
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false, },
          zoom: { enabled: false, },
        },
        colors: ["#033A6D", "#4CAF50", "#FF5252", "#FFC107"],
        responsive: [
          {
            breakpoint: 480,
            options: { legend: { position: "bottom", offsetX: -10, offsetY: 0, }, },
          },
        ],
        dataLabels: { enabled: true, },
        plotOptions: { bar: { horizontal: false, }, },
        xaxis: { type: "label", categories: [], },
        tooltip: { x: { format: "dd MMM yyyy", }, },
        legend: { position: "top", },
        fill: { opacity: 1, },
      },
    };
  },
  methods: {
    async getData() {
      const url = `${this.baseUrl}/history/pw/listchart?companyId=${this.companyId}&year=${this.year}&week=${this.week}`
      try {
        this.loading = true
        const result = await axios.get(url, { headers: { action: 'Get Chart Attedance', actionId: 4 } })
        this.loading = false
        if (result) {
          return result.data.data
        }
      } catch (e) {
        this.loading = false
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    refresh() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    },
    updateChart() {
      this.series = this.data.value ? this.data.value : [{ name: 'Data', data: [] }]
      this.chartOptions = {
        ...this.chartOptions,
        ...{ xaxis: { categories: this.data.label ? this.data.label : [] } }
      }
      this.chartOptions.title.text = this.data.title
      this.refresh()
    }

  },
  computed: {
  },
  watch: {
    // async label() {
    //   this.data = await this.getData()
    //   this.updateChart()
    // },
  },
  async created() {
    if (this.companyId) {
      this.data = await this.getData()
      this.updateChart()
    }
  },
};
</script>
